export default "__VITE_ASSET__9d270e78__"